<template>
    <div id="app">
        <heads></heads>
        <transition :name="transition.name">
            <keep-alive v-if="$route.meta.cache === true">
                <router-view></router-view>
            </keep-alive>
            <router-view v-else>
            </router-view>
        </transition>
    </div>
</template>
<script>
import Heads from "@/components/Heads.vue";
export default {
    name: "App",
    data() {
        return {
            transition: {
                name: "gradient",
            },
            flag:''
        };
    },
    components:{
        Heads,
    },
    created(){
        if (process.env.NODE_ENV != 'development') {
            if (this._isMobile()) {
                if (location.pathname != '/h5/') {
                    window.location.href = 'https://www.vogemotor.com/h5'
                }
            }else{
                if (location.pathname != '/html/') {
                    window.location.href = 'https://www.vogemotor.com/'
                }
            }
        }
    },
  methods:{
    // 判断是否为手机浏览器
    _isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/base.scss";
@import "@/styles/pub.scss";
/* 渐变 */
.gradient-enter-active {
    position: fixed;
    z-index: 2;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    top: 0;
    opacity: 0;
    transition: all 0.3s linear;
    background-color: $app-bg-color-grey;
}
.gradient-enter-to {
    opacity: 1;
}
.gradient-leave-active {
    position: fixed;
    z-index: 1;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    opacity: 1;
    top: 0;
    transition: all 0.3s linear;
    background-color: $app-bg-color-grey;
}
.gradient-leave-to {
    opacity: 0;
}
/* 向左滑动 */
.slide-left-enter-active {
    position: fixed;
    z-index: 2;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    top: 0;
    transform: translateX(100vw);
    transition: all 0.3s ease-out;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, .4);
    background-color: $app-bg-color-grey;
}
.slide-left-enter-to {
    transform: translateX(0);
}
.slide-left-leave-active {
    position: fixed;
    z-index: 1;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    top: 0;
    transition: all 0.3s ease-in;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, .4);
    background-color: $app-bg-color-grey;
}
.slide-left-leave-to {
    transform: translateX(-100vw);
}
/* 向右滑动 */
.slide-right-enter-active {
    position: fixed;
    z-index: 2;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    top: 0;
    transform: translateX(-100vw);
    transition: all 0.3s ease-out;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, .4);
    background-color: $app-bg-color-grey;
}
.slide-right-enter-to {
    transform: translateX(0);
}
.slide-right-leave-active {
    position: fixed;
    z-index: 1;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    top: 0;
    transform: translateX(0);
    transition: all 0.3s ease-in;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, .4);
    background-color: $app-bg-color-grey;
}
.slide-right-leave-to {
    transform: translateX(100vw);
}
.van-icon{
    font-family: 'vant-icon' !important;
}
</style>
